// extracted by mini-css-extract-plugin
module.exports = {"root":"mask_root__1R5w-"};